import CtNumericInpunt from "./CtNumericInpunt"

export default  CtNumericInpunt;



// WEBPACK FOOTER //
// ./src/components/ct-numeric-inpunt/index.js